import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import {
  WaterLeakNotificationService,
  WaterLeakAlert,
} from '../../../services/water-leak-notification.service';

@Component({
  selector: 'app-water-leak-banner',
  templateUrl: './water-leak-banner.component.html',
  styleUrls: ['./water-leak-banner.component.scss'],
  animations: [
    trigger('slideDown', [
      state('visible', style({ transform: 'translateY(0)', opacity: 1 })),
      state('hidden', style({ transform: 'translateY(-100%)', opacity: 0 })),
      transition('hidden => visible', animate('300ms ease-out')),
      transition('visible => hidden', animate('300ms ease-in')),
    ]),
  ],
})
export class WaterLeakBannerComponent implements OnInit, OnDestroy {
  currentAlert: WaterLeakAlert | null = null;
  private destroy$ = new Subject<void>();

  constructor(private waterLeakService: WaterLeakNotificationService) {}

  ngOnInit(): void {
    this.waterLeakService.currentAlert$
      .pipe(takeUntil(this.destroy$))
      .subscribe(alert => {
        this.currentAlert = alert;
      });
  }

  get animationState(): string {
    return this.currentAlert?.isVisible ? 'visible' : 'hidden';
  }

  onYes(): void {
    this.waterLeakService.respondYes();
  }

  onNo(): void {
    this.waterLeakService.respondNo();
  }

  onDismiss(): void {
    this.waterLeakService.dismiss();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
